import { isChunkSafeMode } from '@/components/App/chunkPreloadError';

// Registro del Service Worker (generado por vite-plugin-pwa) que cachea los
// chunks de /assets en la caché local del navegador. Una pestaña abierta sigue
// resolviendo SUS chunks desde la caché aunque deployes 20 veces al día → sin
// 404, sin "Hay una versión nueva", sin reload.
//
// Registro NATIVO a propósito (no usamos `virtual:pwa-register`): no hace falta
// el helper de update porque NO forzamos nada. El SW (skipWaiting:false) queda
// 'waiting' tras un deploy y toma control recién en el próximo full-load natural,
// donde el HTML (no-store) ya trae la versión nueva. Cero pantalla, cero reload.
//
// Excepción: una pestaña en MODO SEGURO (un chunk falló dos veces seguidas y la
// recuperación sacó al SW y sus cachés, ver chunkPreloadError.ts) sigue sin SW hasta
// que se cierre. Registrarlo acá lo volvería a meter (clientsClaim) en el camino de
// los chunks de esa misma pestaña. La próxima apertura de la app lo registra.
export function registerServiceWorker(): void {
  if (import.meta.env.DEV) return;
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) return;
  if (isChunkSafeMode()) return;
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      // Nunca dejar que un fallo de registro del SW rompa la app.
      console.warn('SW register failed (no crítico):', err);
    });
  });
}
